export const MAX_SOURCES = 4;
export const MAX_OBSTACLES = 24;

// Rendering optimization thresholds
export const MIN_VISIBLE_INTENSITY = 0.001;
export const MIN_OPACITY_THRESHOLD = 0.001;